<template>
  <div class="seccion404 timeout-page">
    <section id="servicios" class="secciones seccion-blanca">
      <div class="container">
        <h1>Error: Excedió su tiempo de espera</h1>
        <div class="row">
          <div class="col-md-12">
            <p style="text-align: center;">Tiempo de espera excedido. Inténtelo Nuevamente.</p>
          </div>
        </div>
      </div>
    </section>
    <GoToTrackingModule />
    <MultimediaModule />
  </div>
</template>

<script>
import GoToTrackingModule from '@/modules/GoToTrackingModule.vue';
import MultimediaModule from '@/modules/MultimediaModule.vue';
import _ from 'lodash';
import { errorToaster } from '../../components/shared/service/ErrorHandler';

export default {
  components: { GoToTrackingModule, MultimediaModule },
  methods: {
    scroll_inicio() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.scroll_inicio();
  },
};
</script>
<style lang="scss" src="./Timeout.scss"></style>
